import { render } from "./UpdateMenuItem.vue?vue&type=template&id=ac168392&scoped=true"
import script from "./UpdateMenuItem.vue?vue&type=script&lang=js"
export * from "./UpdateMenuItem.vue?vue&type=script&lang=js"

import "./UpdateMenuItem.vue?vue&type=style&index=0&id=ac168392&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac168392"]])

export default __exports__